import { serialize } from "object-to-formdata";
import { WeekScheduleInput, WeekScheduleView, UpdateCustomStatusInput, StatusHistory, LabeledFaceDescriptorsInput } from "../../models/attendance";
import request from "../../utils/request";
import { Bank, EditBankInput, Result, User, UserBank } from "../../models/general";
import { AxiosResponse } from "axios";
import currency from "../../views/Settings/General/currency";

export async function GetBanks(){
    const response=await request.get<Result<Bank[]>>(`Bank/GetBanks`);
    return response.data;
}
export async function AddBank(input : Bank){
    const response=await request.post<Result<Bank>>(`Bank/AddBank`, input);
    return response.data;
}
export async function EditCompanyBank(bankId: number) {
    const data = { bankdId : bankId }
    const response = await request.post<Result<boolean>>(`Bank/EditCompanyBank`, bankId ,{ headers: { 'Content-Type': 'application/json' }});
    return response.data;
}
export async function DeleteBank(id: number) {
    const response = await request.post<Result<boolean>>(`Bank/DeleteBank/${id}`,{ headers: { 'Content-Type': 'application/json' }});
    return response.data;
}
export async function EditBank(input : EditBankInput ,id: number) {
    const response = await request.post<Result<boolean>>(`Bank/EditBank/${id}`,input,{ headers: { 'Content-Type': 'application/json' }});
    return response.data;
}
export async function EditUserBank(userId: string, bankId: number) {
    const response = await request.post<Result<boolean>>(`Bank/EditUserBank/${userId}`,bankId,{ headers: { 'Content-Type': 'application/json' } });
    return response.data;
}
export async function EditUserBankRule(userId: string, userBankRule: UserBank) {
    const response = await request.post<Result<boolean>>(`Bank/EditUserBankRule/${userId}`,userBankRule,{ headers: { 'Content-Type': 'application/json' } });
    return response.data;
}
